export default __webpack_public_path__ + "static/media/f.9a62cc1a.jpg";